import Drawer from 'react-modern-drawer';
import { FormGroup, Input, Label } from 'reactstrap';
import DefaultButton from '../../../../../components/Buttons/Default';
import { useState, useEffect } from 'react';
import Select from "react-select";
import SelectCustomStyles from '../../../../../utils/styles/reactSelect';
import { useTranslation } from 'react-i18next';
import DefaultDrawer from '../../../../../components/Drawers/Default';
import CustomSelect from '../../../../../components/Forms/CustomSelect';

const EMPTY_FILTERS = {
  name: '',
  company_name: '',
  email: '',
  phone_number: '',
  type: '',
  source: '',
  added_after: '',
  added_before: ''
};

function FiltersDrawer({isOpen, toggle, applyFilters, filters = {}}) {
  const { t } = useTranslation();
  const [filtersData, setFiltersData] = useState({...EMPTY_FILTERS, ...filters});

  useEffect(() => {
    if (isOpen) {
      setFiltersData({...EMPTY_FILTERS, ...filters});
    }
  }, [isOpen]);

  const clearFilters = () => {
    setFiltersData(EMPTY_FILTERS);
    applyFilters({});
  };

  const sourceOptions = [
    { value: 'advertisement', label: t('crm.advertisement') },
    { value: 'campaign', label: t('crm.campaign') },
    { value: 'mass_mailing', label: t('crm.massMailing') },
    { value: 'event', label: t('crm.event') }
  ];

  const statusOptions = [
    { value: 'new', label: t('crm.new') },
    { value: 'contacted', label: t('crm.contacted') },
    { value: 'qualified', label: t('crm.qualified') },
    { value: 'quotation_sent', label: t('crm.quotation_sent') },
    { value: 'negotiation', label: t('crm.negotiation') },
    { value: 'won', label: t('crm.won') },
    { value: 'lost', label: t('crm.lost') }
  ];

  return(
    <DefaultDrawer
      isOpen={isOpen}
      toggle={toggle}
    >
      <div className="p-3 drawer-content">
        <h4 className="fw-bold">{t('common.filter')}</h4>

        <FormGroup>
          <Label>{t('common.name')}: </Label>
          <Input 
            value={filtersData.name}
            onChange={(e) => setFiltersData({...filtersData, name: e.target.value})}
          />
        </FormGroup>
        <FormGroup>
          <Label>{t('settings.companyNameLabel')}: </Label>
          <Input
            value={filtersData.company_name}
            onChange={(e) => setFiltersData({...filtersData, company_name: e.target.value})}
          />
        </FormGroup>
        <FormGroup>
          <Label>{t('common.email')}: </Label>
          <Input
            value={filtersData.email}
            onChange={(e) => setFiltersData({...filtersData, email: e.target.value})}
          />
        </FormGroup>
        <FormGroup>
          <Label>{t('common.phone')}: </Label>
          <Input
            value={filtersData.phone_number}
            onChange={(e) => setFiltersData({...filtersData, phone_number: e.target.value})}
          />
        </FormGroup>
        <FormGroup>
          <Label>{t('common.type')}: </Label>
          <Input
            type="select"
            value={filtersData.type}
            onChange={(e) => setFiltersData({...filtersData, type: e.target.value})}
          >
            <option value="">{t('common.selectType')}</option>
            <option value="client">{t('crm.client')}</option>
            <option value="consultant">{t('crm.consultant')}</option>
            <option value="partner">{t('crm.partner')}</option>
          </Input>
        </FormGroup>
        <FormGroup>
          <Label>{t('crm.source')}: </Label>
          <CustomSelect
            value={filtersData.source}
            onChange={(selected, objectData) => setFiltersData({ ...filtersData, source: selected ? selected.label : '' })}
            module="crm/settings/lead-sources"
            placeholder={t('crm.searchSourcePlaceholder')}
            createLink="/crm/settings"
            responseKey="lead_sources"
          />
        </FormGroup>
        <FormGroup>
          <Label>{t('common.status')} </Label>
          <Select
            value={statusOptions.find(o => o.value === filtersData.status) || null}
            onChange={(selected) => setFiltersData({ ...filtersData, status: selected.value })}
            options={statusOptions}
            styles={SelectCustomStyles}
          />
        </FormGroup>

        <hr />
        
        <FormGroup>
          <Label>{t('common.addedAfter')}</Label>
          <Input
            type="date"
            value={filtersData.added_after}
            onChange={(e) => setFiltersData({...filtersData, added_after: e.target.value})}
          />
        </FormGroup>
        <FormGroup>
          <Label>{t('common.addedBefore')}</Label>
          <Input
            type="date"
            value={filtersData.added_before}
            onChange={(e) => setFiltersData({...filtersData, added_before: e.target.value})}
          />
        </FormGroup>

        <DefaultButton block onClick={() => applyFilters(filtersData)} style={{marginBottom: '10px'}}>
          {t('common.filter')}
        </DefaultButton>

        <DefaultButton block onClick={clearFilters} color="light" outline>
          {t('common.all')}
        </DefaultButton>
      </div>
    </DefaultDrawer>
  );
}

export default FiltersDrawer;